<template>
  <div class="n-buttons-double-group"><slot name="default"></slot></div>
</template>

<script>
export default {
  name: 'NButtonsDoubleGroup'
};
</script>

<style lang="stylus">
.n-buttons-double-group {
  .n-button + .n-button {
    border-radius: 0;
    margin-inline-start: 0;
  }
  .n-button {
    margin: 0;

    &:first-of-type {
      border-radius: var(--border-radius, 5px) 0 0 var(--border-radius, 5px);
      &:before {
        inset-inline-end: 0;
      }
    }
    &:last-of-type {
      border-radius: 0 var(--border-radius, 5px) var(--border-radius, 5px) 0;
    }
  }
}
</style>
